import { render, staticRenderFns } from "./confirm-delete-modal.vue?vue&type=template&id=dd8a83d2"
import script from "./confirm-delete-modal.ts?vue&type=script&lang=ts&external"
export * from "./confirm-delete-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./confirm-delete-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd8a83d2')) {
      api.createRecord('dd8a83d2', component.options)
    } else {
      api.reload('dd8a83d2', component.options)
    }
    module.hot.accept("./confirm-delete-modal.vue?vue&type=template&id=dd8a83d2", function () {
      api.rerender('dd8a83d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/confirm-delete-modal/confirm-delete-modal.vue"
export default component.exports